import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { SelectOption } from "shared/types/Select"
import { WithClassName } from "shared/types/WithClassName"
import { Select } from "shared/ui/input/select/select/Select"

import { useProjectFormContext } from "../contexts/ProjectFormContext"

export interface ProjectFormPhaseChipProps extends WithClassName {
  children?: React.ReactNode
  options?: SelectOption<string>[] | null
}

export const ProjectFormPhase = React.memo(
  ({ className, options: optionsProp }: ProjectFormPhaseChipProps) => {
    const { t } = useTranslation()
    const { isReadonly, isDisabled, model } = useProjectFormContext()

    const options = optionsProp ?? model?.core.data.phases?.data

    return (
      <Select.Root
        name="project.phase"
        label={t("Project.phase")}
        className={classNames("project-form__phase", className)}
        readonly={isReadonly}
        disabled={isDisabled}
      >
        <Select.Label />
        <Select.Input options={options ?? undefined} valueIsOption />
        <Select.Readonly />
        <Select.ErrorMessage />
      </Select.Root>
    )
  }
)

ProjectFormPhase.displayName = "ProjectFormPhaseChip"
